import { Box, Button, TextField, Typography } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import { BookingService } from '../Service'

const ApplyDiscount = (props) => {
    const { bookingDetailsdata, fetchBookingDetalById ,setOpenDiscountModal} = props
    const { control, handleSubmit, formState: { errors } } = useForm({
        mode: 'onChange',
        defaultValues: {
            couponCode: '',
        },
    })
    const submitCouponDiscount = async (data) => {
        console.log('Coupon Code:', data.couponCode);
        const isConfirmed = await Swal.fire({
            title: 'Are you sure?',
            text: `You are about to apply the coupon code ${data.couponCode}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, apply it!',
            cancelButtonText: 'No, cancel!',
            allowOutsideClick: false,
        });
        if (isConfirmed.isConfirmed) {
            Swal.fire({
                title: 'Processing...',
                text: 'Please wait while we apply the discount.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
            try {

                const discountResponse = await BookingService.afterBookingCouponApply({
                    "bookingId": bookingDetailsdata?.id,
                    "timeSlotDate": bookingDetailsdata?.serviceDate,
                    "startTime": bookingDetailsdata.bookingStartTime,
                    "endTime": bookingDetailsdata.bookingEndTime,
                    "useCoin": bookingDetailsdata?.coinValue >0 ? true : false,
                    "couponCode": data.couponCode,
                });

                if (discountResponse.success == "1") {
                    console.log("Discount Response:", discountResponse.data.couponMsg);
                    if(discountResponse.data?.couponId == null){
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: discountResponse?.data.couponMsg?.msg || 'Coupon code is not valid or already used.',
                        });
                        return;
                    }
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Discount applied successfully',
                    });
                    fetchBookingDetalById();
                    Swal.close();
                    setOpenDiscountModal(false);
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Something Went wrong. Please try again.',
                });
                console.error("Error in applying discount coupon:", error);
            }
        }
    }
    
    return (
        <Box sx={{ p: '2%' }} component={'form'} onSubmit={handleSubmit(submitCouponDiscount)}>
            {/* Add discount input and button here */}
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '2%', gap: 1 }}>
                <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>Enter Coupon Code :</Typography>
                <Controller
                    control={control}
                    name="couponCode"
                    rules={{
                        required: 'Enter Coupon Code',
                        // alphanumeric and maximum 12 characters
                        pattern: {
                            value: /^[a-zA-Z0-9]{1,12}$/,
                            message: 'Coupon Code must be alphanumeric and maximum 12 characters',
                        },
                    }}
                    render={({ field, fieldState: { error } }) => (
                        <TextField
                            {...field}
                            size='small'
                            variant='outlined'
                            placeholder='Enter Coupon Code'
                            // error={!!error}
                            // helperText={error ? error.message : ''}
                            InputProps={{
                                style: { fontSize: '0.75rem' }
                            }}
                            onChange={(e) => {
                                const value = e.target.value;
                                //uppercase the value and max length 12
                                const formattedValue = value.toUpperCase().slice(0, 12);
                                field.onChange(formattedValue);
                            }}
                        />
                    )}
                />
            </Box>
            {errors?.couponCode && (
                <Typography sx={{ color: '#d32f2f', fontSize: '.7rem', textAlign: 'center' }}>
                    {errors?.couponCode?.message}
                </Typography>
            )}
            <Box sx={{ textAlign: 'center' }}>
                <Button
                    size='small'
                    variant="contained"
                    color="primary"
                    sx={{ textTransform: 'none' }}
                    type='submit'
                >
                    Apply Discount
                </Button>
            </Box>
        </Box>
    )
}

export default ApplyDiscount